import React from 'react';

import { FieldProps } from '@api';
import { Form } from '@ui-library/form';
import { Switch } from '@ui-library/switch';
import { RedAsterisk } from '@components/common/redAsterisk';

export const SwitchField: React.FC<FieldProps<'switchField'>> = ({ fieldConfig }) => (
  <Form.Item
    name={fieldConfig.key}
    label={[fieldConfig.label, fieldConfig.optional ? '' : <RedAsterisk />]}
    extra={fieldConfig.info}
    valuePropName="checked"
    rules={[{ required: !fieldConfig.optional }, ...(fieldConfig.rules ?? [])]}
    initialValue={fieldConfig.default}
  >
    <Switch disabled={fieldConfig.disabled} />
  </Form.Item>
);
